import styled from '@emotion/styled';
import { Download } from 'react-feather';
import { BaseMessageButton } from './Message.Button';

type Props = {
  className?: string;
  label?: string;
  onClick: () => void;
};

export const BaseDownloadButton = ({ onClick, className, label = 'Download' }: Props) => {
  return (
    <BaseMessageButton
      onClick={onClick}
      className={className}>
      <StyledIcon size={16} />
      <ButtonCopy>{label}</ButtonCopy>
    </BaseMessageButton>
  );
};

const ButtonCopy = styled.div({
  marginLeft: 5,
});

const StyledIcon = styled(Download)(({ theme }) => ({
  fontSize: 18,
}));